import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import styles from '../../assets/styles/colors.scss';
import MapMarkerIcon from '../Iconoclast/MapMarkerIcon';
import delaysIndicatorGrey from '../../assets/images/delays-icon-inactive.svg';
import delaysIndicatorRed from '../../assets/images/delays-icon-active.svg';

export class MobileLocationMapMarker extends React.Component {
  
  constructor(props) {
    super(props);
    MobileLocationMapMarker.propTypes = {
      location: PropTypes.object.isRequired,
      /** 
       * handler for when the pin is clicked - 
       * passes location back to parent so parent can center map etc
       * */
      onClick: PropTypes.func,
    };

    const { currentUser } = props;
    const { primary_company_id, current_company_id } = localStorage;
    if (
      currentUser.super_admin ||
      (currentUser.role_name == 'admin' && primary_company_id == current_company_id)
    ) {
      this.userCanViewAllDelays = true;
    }

    this.handleOnClick = this.handleOnClick.bind(this);
  }

  handleOnClick(e) {
    e.stopPropagation();
    const { onClick, location } = this.props;
    if (onClick) {
      onClick(location);
    }
  }
  
  render() {
    const { location } = this.props;
    
    if (!location) {
      return null;
    }
    let markerColor = styles.nonExistant;
    let projectCount = 0;
    if (location.in_progress_projects_count >= 0 && location.not_started_projects_count >= 0) {
      markerColor = location.in_progress_projects_count > 0 ? styles.inProgress : styles.nonExistant;
      projectCount = location.in_progress_projects_count + location.not_started_projects_count;
    }
    let delaysIndicator;
    if (location.has_unread_alerts) {
      delaysIndicator = <img className='location-map-marker__delay-indicator' src={delaysIndicatorRed} alt='active delay' />;
    }
    else if (location.has_alerts || (location.has_delays && this.userCanViewAllDelays)) {
      delaysIndicator = <img className='location-map-marker__delay-indicator' src={delaysIndicatorGrey} alt='inactive delay' />;
    }

    return (
      <div className="location-map-marker" onClick={this.handleOnClick} key={'map_marker-' + location.id}>
        {delaysIndicator}
        <MapMarkerIcon id={'location_map'} fillColor={markerColor}  />
        <span className="location-map-marker__count" >{projectCount}</span>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.new_users.currentUser,
  };
};

export default connect(mapStateToProps)(MobileLocationMapMarker);



// WEBPACK FOOTER //
// ./src/components/MobileLocationMapMarker/index.js